import React from 'react'
import PropTypes from 'prop-types'
import { Input, Form } from 'antd'

const TextAreaInput = props => {
  const {
    inputType,
    label,
    name,
    value,
    required,
    disabled,
    handleChange,
    placeholder,
    className
  } = props

  return (
    <React.Fragment>
      <Form.Item
        name={name}
        label={<>{label ? label : ''} </>}
        initialValue={value}
        rules={[
          {
            required: required
          }
        ]}
        colon={false}
      >
        <Input.TextArea
          type={inputType}
          className={`form_input_muted ${className}`}
          id={name}
          value={value}
          defaultValue={value}
          onChange={handleChange}
          name={name}
          placeholder={placeholder}
          rows={4}
          disabled={disabled ? true : false}
          size="middle"
        />
      </Form.Item>
    </React.Fragment>
  )
}

TextAreaInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  inputType: PropTypes.string,
  value: PropTypes.any,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool
}

export default TextAreaInput
